// extracted by mini-css-extract-plugin
export default {"teamCardAddNewButton":"TeamCardOverride_teamCardAddNewButton__mHuie","textOverflowEllipsis":"TeamCardOverride_textOverflowEllipsis__gTWy-"};